import axios from 'axios';

// Richiesta generica di export ASINCRONO: il backend prende in carico, prepara il
// file, lo carica su S3 e avvisa via mail + notifica. Qui rispondiamo subito.
const actions = {
	request: async (context, { type, format, filters = {} }) => {
		let url = 'exports';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{ type, format, filters },
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => res.data)
			.catch(err => {
				console.log('errore export', err?.response?.status);
				return { error: err?.response?.status || true };
			});
	},
};

export default {
	namespaced: true,
	actions,
};
